import styled from "styled-components";
import { Control, FieldValues } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { DivSelectField } from "components/common/style/SelectField/DivSelectField";
import { TAG_RESOURCE_TYPE_OPTIONS } from "constant/search/tag_search";

type TagSelectTypeProps = {
  control: Control<FieldValues, any>;
  fieldName: string;
  defaultValue?: string;
};

const TagSelectResourceType = ({
  control,
  fieldName,
  defaultValue,
}: TagSelectTypeProps) => {
  return (
    <DivSort>
      <label>Resource type</label>
      <DivSelectField>
        <SelectField
          label=""
          name={fieldName}
          control={control as unknown as Control<FieldValues, any>}
          options={TAG_RESOURCE_TYPE_OPTIONS}
          defaultValue={defaultValue}
          onSelect={(val: any) => {}}
        />
      </DivSelectField>
    </DivSort>
  );
};

const DivSort = styled.div`
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  input {
    width: 5rem;
  }
`;

export default TagSelectResourceType;
